export default __webpack_public_path__ + "static/media/imagenPantallasDesktop.ee8ea92f.png";